<template>
	<div class="login">
		<div class="main">
			<img
				class="login-banner"
				src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new/login_banner.png"
				alt=""
			/>
			<div class="login-form">
				<nut-form
					class="login-form"
					:model-value="formData"
					ref="formRef"
				>
					<nut-form-item
						prop="mobile"
						required
						:rules="[{ required: true, message: '请输入用户名' }]"
					>
						<nut-icon
							class="icon"
							font-class-name="iconfont"
							class-prefix="icon"
							name="user"
						/>
						<nut-input
							v-model="formData.mobile"
							class="input-text"
							placeholder="请输入手机号"
							type="tel"
						/>
					</nut-form-item>
					<nut-form-item
						prop="password"
						required
						:rules="[{ required: true, message: '请输入密码' }]"
					>
						<nut-icon
							class="icon"
							font-class-name="iconfont"
							class-prefix="icon"
							name="lock"
						/>
						<nut-input
							v-model="formData.password"
							class="input-text"
							placeholder="请输入密码"
							type="password"
						/>
					</nut-form-item>
				</nut-form>
			</div>
			<p class="forget">
				<a
					href="javascript:;"
					v-if="showRegisterInBtn"
					@click="handleRegister"
					>用户注册</a
				>
				<a
					href="javascript:;"
					v-if="showFindPasswordBtn"
					@click="visible = true"
					>忘记密码?</a
				>
			</p>
			<div class="btn-container">
				<nut-button
					v-if="showAccountInBtn"
					class="btn"
					block
					type="primary"
					@click="handleLogin"
				>
					登录
				</nut-button>
				<nut-button
					v-if="showGuestInBtn"
					plain
					block
					type="primary"
					@click="handleGuestIn"
				>
					游客登录
				</nut-button>
				<nut-button
					v-if="showWxInBtn"
					plain
					block
					type="primary"
					style="margin: 16px 0"
					@click="handleWxIn"
				>
					免密码登录
				</nut-button>
				<nut-button
					v-if="showEnterpriseInBtn"
					block
					type="primary"
					style="margin: 16px 0"
					@click="handleEnterpriseIn"
				>
					企业登录
				</nut-button>
				<help-text-tip
					style="margin: 16px 0"
					@click="handleOpenDialog(LOGIN_HELP)"
				></help-text-tip>
			</div>
		</div>
		<a class="copyright" target="_blank" href="https://beian.miit.gov.cn">
			沪ICP备12024437号-7
		</a>
	</div>

	<forget-password v-model="visible"></forget-password>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import MD5 from 'crypto-js/md5';
import { HelpTextTip } from '@/components';
import ForgetPassword from './components/forgetPassword.vue';
import useNavigate from '@/hooks/useNavigate';
import useDialog from '@/hooks/useDialog';
import { setStorage, getStorage } from '@/utils/util';
import { UUID, USER_MOBILE } from '@/constants';
import { loginApi } from '@/apis';
import { LOGIN_HELP } from '@/constants/tiptype';

export default {
	name: 'Login',
	components: {
		ForgetPassword,
		HelpTextTip,
	},
	setup() {
		const store = useStore();
		const route = useRoute();
		const visible = ref(false);
		const formRef = ref(null);
		const formData = reactive({
			mobile: getStorage(USER_MOBILE) || '',
			password: '',
		});
		const { push } = useNavigate();
		const { handleOpenDialog } = useDialog();
		const tempUuid = ref(''); // todo 临时的uuid 待移除相关逻辑，仅供调试
		const showRegisterInBtn = ref(true);
		const showFindPasswordBtn = ref(false);
		const showAccountInBtn = ref(true);
		const showGuestInBtn = ref(false);
		const showWxInBtn = ref(false);
		const showEnterpriseInBtn = ref(false);
		const handleLogin = async () => {
			formRef.value.validate().then(async ({ valid }) => {
				if (valid) {
					const { mobile, password } = formData;
					const result = await store.dispatch('user/login', {
						username: mobile,
						password: MD5(password).toString(),
						uuid:
							tempUuid.value ||
							route.query.uuid ||
							getStorage(UUID),
					});
					setStorage(USER_MOBILE, mobile); // 缓存mobile
					result && push('/');
				}
			});
		};
		const handleGuestIn = async () => {
			const result = await store.dispatch('user/guestIn', {
				uuid: tempUuid.value || route.query.uuid || getStorage(UUID),
			});
			result && push('/');
		};
		const handleWxIn = async () => {
			const result = await store.dispatch('user/wxIn', {
				uuid: tempUuid.value || route.query.uuid || getStorage(UUID),
			});
			result && push('/');
		};
		const handleEnterpriseIn = async () => {
			const result = await store.dispatch('user/enterpriseIn', {
				uuid: tempUuid.value || route.query.uuid || getStorage(UUID),
			});
			result && push('/');
		};
		const handleRegister = () => {
			push('/register');
		};
		onMounted(() => {
			const uuid = route.query.uuid ? route.query.uuid : '';
			setStorage(UUID, uuid);
			validUuid(uuid);
		});
		// 页面加载校验uuid
		const validUuid = async (uuid) => {
			const res = await loginApi.on_board({
				uuid,
			});
			showRegisterInBtn.value = res.register_in;
			showFindPasswordBtn.value = res.find_password;
			showAccountInBtn.value = res.account_in;
			showGuestInBtn.value = res.guest_in;
			showWxInBtn.value = res.wx_in;
			showEnterpriseInBtn.value = res.enterprise_in;
			res.phone && (formData.mobile = res.phone);
			if (res.uuid) {
				tempUuid.value = res.uuid; //TODO 临时调试用...
				setStorage(UUID, res.uuid); //TODO 临时调试用...
			}
		};

		return {
			formRef,
			formData,
			visible,
			showFindPasswordBtn,
			showRegisterInBtn,
			showAccountInBtn,
			showGuestInBtn,
			showWxInBtn,
			showEnterpriseInBtn,
			LOGIN_HELP,
			handleLogin,
			handleGuestIn,
			handleWxIn,
			handleEnterpriseIn,
			handleRegister,
			handleOpenDialog,
		};
	},
};
</script>

<style lang="scss" scoped>
.login {
	height: 100vh;
	background: #fff;
	@include flex-column-center;
	justify-content: space-between;
	.main {
		width: 100%;
	}
}
.login-banner {
	display: block;
	width: 100%;
	height: (100vw * 380 / 734);
}
.login-form {
	:deep(.nut-form-item__body__slots) {
		position: relative;
		display: flex;
		align-items: center;
	}
	.icon {
		color: #666;
	}
	.input-text {
		flex: 1;
		padding: 0;
		border-bottom: none;
		line-height: 28px;
	}

	:deep(.nut-form-item__label) {
		line-height: 28px;
	}
	:deep(.nut-cell) {
		&:last-child::after {
			border-bottom: 2px solid #f5f6f7 !important;
		}
	}
}

.forget {
	@include flex-center;
	flex-direction: row-reverse;
	justify-content: space-between;
	padding: 0 16px;
	text-align: right;
	line-height: 45px;
	font-size: 14px;
	a {
		color: $primary-color;
	}
}

.register {
	padding: 0 16px;
	text-align: left;
	line-height: 45px;
	font-size: 14px;
	a {
		color: $primary-color;
	}
}

.btn-container {
	.btn {
		margin-bottom: 16px;
	}
}

.copyright {
	padding-bottom: 24px;
	color: #999aaa;
	font-size: 12px;
}
</style>
